/** @format */

import React from 'react'

const Careers = () => {
	return <div>Career Page</div>
}

export default Careers
